import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse, faMoon } from '@fortawesome/free-solid-svg-icons'
import AuthLogin from "./AuthLogin";

type DarkMode = {
  updateData: (data: {
    darkMode: boolean,
    theme: string
  }) => void;
};

function NavBar({ updateData }: DarkMode) {
  const [darkMode, setDarkMode] = useState<boolean>(false);
  const [theme, setTheme] = useState<string>("cupcake");
  const handleDarkModeToggleChange = () => {
    if (darkMode) {
      setTheme("cupcake");
    } else {
      setTheme("dark");
    }
    setDarkMode(!darkMode);
  };

  useEffect(() => {
    const data = {
      darkMode: darkMode,
      theme: theme
    }
    updateData(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [darkMode, theme]);


  return (
    <>
      <div className="navbar bg-base-100">
        <div className="navbar-start">
          <Link to="/" className="btn btn-ghost normal-case text-xl"><FontAwesomeIcon icon={faHouse} className="mr-2" />Mortgage Modeller</Link>
          <div className="dropdown">
            <label tabIndex={0} className="btn btn-ghost lg:hidden">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
            </label>
            <ul tabIndex={0} className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/modeller">Modeller</Link></li>
            </ul>
          </div>
          <ul className="menu menu-horizontal">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/modeller">Modeller</Link></li>
          </ul>
        </div>
        <div className="ml-auto pt-3 pr-4 gap-x-2">
          <AuthLogin/>
          <FontAwesomeIcon icon={faMoon} className="h-8"/> 
          <input type="checkbox" data-toggle-theme="cupcake,sunset" className="toggle" data-act-class="ACTIVECLASS" checked={darkMode} onChange={handleDarkModeToggleChange} />
        </div>
      </div>
    </>
  );
}

export default NavBar;